import type { RouteRecordRaw } from 'vue-router';

export const timesheetsRoutes: RouteRecordRaw[] = [
  {
    path: 'timesheets',
    name: 'timesheets',
    component: () => import('./pages/TimesheetsListPage.vue'),
    meta: { title: 'Timesheets', requiresAuth: true },
  },
];
